import { render } from "./carteComponent.vue?vue&type=template&id=38d9ffc1&scoped=true"
import script from "./carteComponent.vue?vue&type=script&lang=js"
export * from "./carteComponent.vue?vue&type=script&lang=js"

import "./carteComponent.vue?vue&type=style&index=0&id=38d9ffc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d9ffc1"]])

export default __exports__